import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('common/system', ['system']),
    instances() {
      return this.$store.getters['overview/system/get'];
    },
  },
};
